var map = {
	"./apple_icon.png": 43053,
	"./discord_icon.png": 28810,
	"./email_icon.png": 64082,
	"./facebook_fff_icon.png": 83543,
	"./facebook_icon.png": 63078,
	"./github_icon.png": 45801,
	"./google_fff_icon.png": 10989,
	"./google_icon.png": 98286,
	"./jwt_icon.png": 89874,
	"./linkedin_icon.png": 19841,
	"./microsoft_icon.png": 18622,
	"./phone_icon.png": 71314,
	"./telegram_icon.png": 50835,
	"./twitch_icon.png": 54160,
	"./twitter_fff_icon.png": 19108,
	"./twitter_icon.png": 49937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29686;